import React, {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import {OrderWrapper} from '../pages/order/OrderWrapper'
import {OrderCreate} from '../pages/order/OrderCreate'
import {OrderDetail} from '../pages/order/OrderDetail'
import {OrderAmandemen} from '../pages/order/OrderAmandemen'
import {TableRevisiSIP} from '../pages/order/TableRevisiSIP'
import {OrderSupport} from '../pages/order/CustomerSupport'
import {OrderDetailSales} from '../pages/order/OrderDetailSales'
import {OrderEdit} from '../pages/order/OrderEdit'
import {KontrakWrapper} from '../pages/kontrak/KontrakWrapper'
import {KontrakCreate} from '../pages/kontrak/KontrakCreate'
import {KontrakDetail} from '../pages/kontrak/KontrakDetail'
import {KontrakEdit} from '../pages/kontrak/KontrakEdit'
import {KontrakSub} from '../pages/kontrak/KontrakSub'
import {SOWrapper} from '../pages/so/SOWrapper'
import {SOCreate} from '../pages/so/SOCreate'
import {SOReviseNew as SORevise} from '../pages/so/SORevise'
import {SODetail} from '../pages/so/SODetail'
import {SIWrapper} from '../pages/si/SIWrapper'
import {SICreate} from '../pages/si/SICreate'
import {SIPDetail} from '../pages/si/SIPDetail'
import {SIPEdit} from '../pages/si/SIPEdit'
import {FinancialWrapper} from '../pages/financial_doc/FinancialWrapper'
import {FinancialCreate} from '../pages/financial_doc/FinancialCreate'
import {FinancialDetail} from '../pages/financial_doc/FinancialDetail'
import {UserWrapper} from '../pages/userManagement/userWrapper'
import {RoleWrapper} from '../pages/roleManagement/roleWrapper'
import {MenuWrapper} from '../pages/menuManagement/menuWrapper'
import {MaterialWrapper} from '../pages/masterData/materialProduct/materialWrapper'
import {CustomerWrapper} from '../pages/masterData/customer/customerWrapper'
import {PlantWrapper} from '../pages/masterData/plant/plantWrapper'
import {PlantAWrapper} from '../pages/masterData/plant/plantAWrapper'
import {OfficeWrapper} from '../pages/masterData/salesOffice/OfficeWrapper'
import {AreaWrapper} from '../pages/masterData/salesArea/AreaWrapper'
import {PriceWrapper} from '../pages/masterData/priceList/PriceWrapper'
import {PriceJbpWrapper} from '../pages/masterData/priceList/PriceWrapperJbp'
import {PriceNonJbpWrapper} from '../pages/masterData/priceList/PriceWrapperNonJbp'
import {CreateJbp} from '../pages/masterData/priceList/CreateJbp'
import {NonJbpCreate} from '../pages/masterData/priceList/NonJbpCreate'
import {EditJbp} from '../pages/masterData/priceList/EditJbp'
import {IncotermWrapper} from '../pages/masterData/incoterm/incotermWrapper'
import {TopWrapper} from '../pages/masterData/top/topWrapper'
import {BankWrapper} from '../pages/masterData/bank/BankWrapper'
import {EndUserWrapper} from '../pages/masterData/end-user/endUserWrapper'
import {AddEnduser} from '../pages/masterData/end-user/AddEndUser'
import {EditEnduser} from '../pages/masterData/end-user/EditEndUser'
import {DoWrapper} from '../pages/do/doWrapper'
import {AuditWrapper} from '../pages/audit/auditWrapper'
import {AccessWrapper} from '../pages/access/AccessWrapper'
import {NewsWrapper} from '../pages/content/news/NewsWrapper'
import {AddNews} from '../pages/content/news/AddNews'
import {EditNews} from '../pages/content/news/EditNews'
import {Test} from '../pages/testing/Test'
import {ChangePassword} from '../pages/changePassword/ChangePassword'
import {InvoiceWrapper} from '../pages/invoice/InvoiceWrapper'

import {ApprovalWrapperKontrak} from '../pages/approval/ApprovalWrapperKontrak'
import {ApprovalWrapperSIP} from '../pages/approval/ApprovalWrapperSIP'
import {ApprovalWrapperSO} from '../pages/approval/ApprovalWrapperSO'

import {UserLevelWrapper} from '../pages/userLevel/UserLevelWrapper'

import {TableOffer} from '../pages/content/offer/TableOffer'
import {LogWrapper} from '../pages/log/sap/logWrapper'
import {LogH2HWrapper} from '../pages/log/h2h/logH2HWrapper'
import {APIWrapper} from '../pages/log/management/logWrapper'

import {WrapperAContract} from '../pages/approvalLevel/WrapperAContract'
import {WrapperASIP} from '../pages/approvalLevel/WrapperASIP'
import {WrapperASO} from '../pages/approvalLevel/WrapperASO'
import {ApprovalKontrakDetail} from '../pages/approval/ApprovalKontrakDetail'
import {ApprovalSIPDetail} from '../pages/approval/ApprovalSIPDetail'
import {ApprovalSODetail} from '../pages/approval/ApprovalSODetail'
import {ApprovalWrapperOrder} from '../pages/approval/ApprovalWrapperOrder'
import {ApprovalOrderDetail} from '../pages/approval/ApprovalOrderDetail'
import Notification from '../../_metronic/layout/components/Notification'

import {SynchroWrapper} from '../pages/syncro/SyncroWrapper'

import {LetterWrapper} from '../pages/config_letter/LetterWrapper'
import {AddLetter} from '../pages/config_letter/AddLetter'
import {TanggalWrapper} from '../pages/configTanggal/TanggalWrapper'

import {List as ConfigurationSigningList} from '../pages/configuration/signing/List'
import {FormAdd as ConfigurationSigningAdd} from '../pages/configuration/signing/Add'

import {List as ConfigurationPaymentDueDateList} from '../pages/configuration/payment-due-date/List'
import {FormAdd as ConfigurationPaymentDueDateAdd} from '../pages/configuration/payment-due-date/Add'

import {List as ConfigurationFileList} from '../pages/configuration/file/List'

import {PPNWrapper} from '../pages/masterData/masterPPN/PPNWrapper'
import {TransportWrapper} from '../pages/masterData/Transport/TransportWrapper'
import {RouteWrapper} from '../pages/masterData/DataRoute/routeWrapper'
import {useSelector} from 'react-redux'
import {LogMasterDataPage} from '../pages/log/master-data/LogMasterDataPage'
import {LogAuthPage} from '../pages/log/auth/LogAuthPage'
import {LogPeruri} from '../pages/log/peruri/LogPeruri'
import {LogQueue} from '../pages/log/queue/Index'
import {NonJBPEditPage} from '../pages/masterData/priceList/NonJBPEditpage/NonJBPEditPage'
import {SettingConfigWrapper} from '../pages/settingConfig/SettingConfigWrapper'
import NotificationsPage from '../pages/notifications/NotificationsPage'
import {WrapperAOrder} from '../pages/approvalLevel/WrapperAOrder'

import {
  JBPType as MasterJBPType
} from '../pages/masterData/jbp-pricing/jbp-type/Index'
import {
  JBP as MasterJBP
} from '../pages/masterData/jbp-pricing/jbp/Index'
import {
  Create as MasterJBPCreate
} from '../pages/masterData/jbp-pricing/jbp/Create'
import {
  Pricing as MasterPricing
} from '../pages/masterData/jbp-pricing/pricing/Index'
import {
  CheckStock as MasterCheckStock
} from '../pages/masterData/check-stock/Index'
import {
  Create as MasterPricingCreate
} from '../pages/masterData/jbp-pricing/pricing/Create'
import {
  Index as MasterSupplyPoint
} from '../pages/masterData/supply-point/Index'
import { KontrakRevisi } from '../pages/kontrak/KontrakRevisi'
import { LogSalesOrderWrapper } from '../pages/log/management/sales-order/LogSalesOrderWrapper'
import { OptionalTextWrapper } from '../pages/configuration/optional-text/LetterWrapper'
import { AddOptionalText } from '../pages/configuration/optional-text/AddLetter'

const PrivateRoutes = () => {
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))
  const resetToken = useSelector((state: any) => state.notif.token)
  // console.log(resetToken, ' redux token')
  return (
    <Notification>
      <Routes key={resetToken}>
        <Route element={<MasterLayout />}>
          {/* Redirect to Dashboard after success login/registartion */}
          <Route path='auth/*' element={<Navigate to='/dashboard' />} />
          {/* Pages */}
          <Route path='dashboard' element={<DashboardWrapper />} />

          <Route path='change-password' element={<ChangePassword />} />

          {/* Order */}
          <Route path='management/order' element={<OrderWrapper />} />
          <Route path='management/order/:type' element={<OrderWrapper />} />
          <Route path='management/order/detail/:id' element={<OrderDetail />} />
          <Route path='management/order/detail/support' element={<OrderSupport />} />
          <Route path='management/order/create' element={<OrderCreate />} />
          <Route path='management/order/detailsales' element={<OrderDetailSales />} />
          <Route path='management/order/edit' element={<OrderEdit />} />
          <Route path='management/order/amandemen/:id' element={<OrderAmandemen />} />
          <Route path='management/order/amandemen/:id/:type' element={<OrderAmandemen />} />
          <Route path='management/order/tablesip/:id' element={<TableRevisiSIP />} />
          {/* End Order */}

          {/* Kontrak */}
          <Route path='management/kontrak' element={<KontrakWrapper />} />
          <Route path='management/kontrak/' element={<KontrakWrapper />} />
          <Route path='management/kontrak/create' element={<KontrakCreate />} />
          {/* management/kontrak/detail/id */}

          {/* Kontrak */}
          <Route path={`management/kontrak/detail`} element={<KontrakDetail />} />
          <Route path={`management/kontrak/detail/:id`} element={<KontrakDetail />} />
          <Route path={`management/kontrak/revisi/:id`} element={<KontrakRevisi />} />
          <Route path={`management/kontrak/edit`} element={<KontrakEdit />} />
          <Route path='management/kontrak/detail/sub' element={<KontrakSub />} />
          {/* End Kontrak */}

          {/* SO */}
          <Route path='management/so' element={<SOWrapper />} />
          <Route path='management/so/create' element={<SOCreate />} />
          <Route path='management/so/detail' element={<SODetail />} />
          <Route path='management/so/detail/:id' element={<SODetail />} />
          <Route path='management/so/revise/:id' element={<SORevise />} />
          {/* End SO */}

          {/* SI */}
          <Route path='management/si' element={<SIWrapper />} />
          <Route path='management/si/:type' element={<SIWrapper />} />
          <Route path='management/si/create' element={<SICreate />} />
          <Route path='management/sip/detail' element={<SIPDetail />} />
          <Route path='management/sip/detail/:id' element={<SIPDetail />} />
          <Route path='management/sip/edit/:id' element={<SIPEdit />} />
          {/* End SI */}

          {/* DO */}
          <Route path='management/do' element={<DoWrapper />} />
          {/* End DO */}

          <Route path='management/invoice' element={<InvoiceWrapper />} />

          {/* Financial */}
          <Route path='financial' element={<FinancialWrapper />} />
          <Route path='financial/create' element={<FinancialCreate />} />
          <Route path='financial/detail' element={<FinancialDetail />} />
          {/* End Financial */}

          {/* Approval */}
          <Route path='configuration/approval/order' element={<WrapperAOrder />} />
          <Route path='configuration/approval/sip' element={<WrapperASIP />} />
          <Route path='configuration/approval/contract' element={<WrapperAContract />} />
          <Route path='configuration/approval/sales-order' element={<WrapperASO />} />

          {/* User */}
          <Route path='user' element={<UserWrapper />} />
          {/* End User */}

          {/* Role */}
          <Route path='role' element={<RoleWrapper />} />
          {/* End Role */}

          {/* Menu */}
          <Route path='menu' element={<MenuWrapper />} />
          {/* End Menu */}

          {/* Access */}
          <Route path='access' element={<AccessWrapper />} />
          {/* End Access */}

          {/* Audit */}
          <Route path='audit' element={<AuditWrapper />} />
          {/* End Audit */}

          {/* News */}
          <Route path='content/news' element={<NewsWrapper />} />
          <Route path='content/news/create' element={<AddNews className={''} />} />
          <Route path='content/news/edit' element={<EditNews className={''} />} />
          {/* End News */}

          {/* Offer */}
          <Route path='content/offer' element={<TableOffer className={''} />} />

          {/* Material */}
          <Route path='master/material' element={<MaterialWrapper />} />
          {/* End Material */}

          {/* Customer */}
          <Route path='master/customer' element={<CustomerWrapper />} />
          {/* End Customer */}

          {/* Route */}
          <Route path='master/route' element={<RouteWrapper />} />
          {/* Route */}

          {/* Plant */}
          <Route path='master/plant/assignment' element={<PlantAWrapper />} />
          <Route path='master/plant/all' element={<PlantWrapper />} />
          {/* End Plant */}

          {/* Office */}
          <Route path='master/office' element={<OfficeWrapper />} />
          {/* End Office */}

          {/* Area */}
          <Route path='master/area' element={<AreaWrapper />} />
          {/* End Area */}

          {/* Price */}
          <Route path='master/price/dasar' element={<PriceWrapper />} />
          <Route path='master/price/jbp' element={<PriceJbpWrapper />} />
          <Route path='master/price/non-jbp' element={<PriceNonJbpWrapper />} />
          <Route path='master/price/non-jbp/create' element={<NonJbpCreate className={''} />} />
          <Route path='master/price/jbp/create' element={<CreateJbp className={''} />} />
          <Route path='master/price/jbp/edit/:id' element={<EditJbp className={''} />} />
          <Route path='master/price/non-jbp/edit' element={<NonJBPEditPage />} />
          {/* End Price */}

          {/* Incoterm */}
          <Route path='master/incoterm' element={<IncotermWrapper />} />
          {/* End Incoterm */}

          {/* Bank */}
          <Route path='master/bank' element={<BankWrapper />} />
          {/* End Bank */}

          {/* Transport */}
          <Route path='master/transport' element={<TransportWrapper />} />
          {/* Transport */}

          {/* new jbp pricing */}
          <Route path='master/type-jbp' element={<MasterJBPType />} />
          <Route path='master/jbp' element={<MasterJBP />} />
          <Route path='master/jbp/create' element={<MasterJBPCreate className="" />} />
          <Route path='master/jbp/edit/:id' element={<MasterJBPCreate className="" />} />
          <Route path='master/pricing' element={<MasterPricing />} />
          <Route path='master/pricing/create' element={<MasterPricingCreate className="" />} />
          <Route path='master/pricing/edit/:type/:id' element={<MasterPricingCreate className=""/>} />

          <Route path='master/supply-point' element={<MasterSupplyPoint />} />
          <Route path='master/check-stock' element={<MasterCheckStock />} />
          {/*  */}

          {/* Approval Level */}
          <Route path='approval/sip' element={<ApprovalWrapperSIP />} />
          <Route path='approval/sales-order' element={<ApprovalWrapperSO />} />
          <Route path='approval/contract' element={<ApprovalWrapperKontrak />} />
          <Route path='approval/sip/detail/:id' element={<ApprovalSIPDetail />} />
          <Route path='approval/contract/detail/:id' element={<ApprovalKontrakDetail />} />
          <Route path='approval/sales-order/detail/:id' element={<ApprovalSODetail />} />
          <Route path='approval/order' element={<ApprovalWrapperOrder />} />
          <Route path='approval/order/:id/:type' element={<ApprovalOrderDetail />} />

          {/* User Level */}
          <Route path='configuration/user-level' element={<UserLevelWrapper />} />

          {/* Setting Config */}
          <Route path='configuration/setting' element={<SettingConfigWrapper />} />

          <Route path='synchronize' element={<SynchroWrapper />} />

          {/* Top */}
          <Route path='master/top' element={<TopWrapper />} />
          {/* End Top */}

          {/* Top */}
          <Route path='config/letter' element={<LetterWrapper />} />
          <Route path='config/letter/add' element={<AddLetter className={''} />} />
          <Route path='config/date' element={<TanggalWrapper />} />
          <Route path='config/optional-text' element={<OptionalTextWrapper />} />
          <Route path='config/optional-text/add' element={<AddOptionalText className={''} />} />
          {/* End Top */}

          {/* konfigurasi signing */}
          <Route path='configuration/signing' element={<ConfigurationSigningList />} />
          <Route path='configuration/signing/add' element={<ConfigurationSigningAdd />} />

          <Route path='configuration/payment-due-date' element={<ConfigurationPaymentDueDateList />} />
          <Route path='configuration/payment-due-date/add' element={<ConfigurationPaymentDueDateAdd />} />

          <Route path='configuration/file' element={<ConfigurationFileList />} />

          {/* EndUser */}
          <Route path='master/enduser' element={<EndUserWrapper />} />
          <Route path='master/enduser/add' element={<AddEnduser className={''} />} />
          <Route path='master/enduser/edit/:id' element={<EditEnduser className={''} />} />
          {/* End EndUser */}

          <Route path='master/masterppn' element={<PPNWrapper />} />

          {/* Lazy Modules */}
          <Route path='user-guide' element={<BuilderPageWrapper />} />
          {/* End Lazy Modules */}

          {/* Test */}
          <Route path='test' element={<Test />} />
          {/* End Test */}

          <Route path='log/sap' element={<LogWrapper />} />
          <Route path='log/h2h' element={<LogH2HWrapper />} />
          <Route path='log/api' element={<APIWrapper />} />
          <Route path='log/so' element={<LogSalesOrderWrapper />} />
          <Route path='log/master-data' element={<LogMasterDataPage />} />
          <Route path='log/auth' element={<LogAuthPage />} />
          <Route path='log/peruri' element={<LogPeruri />} />
          <Route path='log/queue' element={<LogQueue />} />

          <Route
            path='notifications/*'
            element={
              <SuspensedView>
                <NotificationsPage />
              </SuspensedView>
            }
          />

          <Route
            path='crafted/pages/profile/*'
            element={
              <SuspensedView>
                <ProfilePage />
              </SuspensedView>
            }
          />
          <Route
            path='crafted/pages/wizards/*'
            element={
              <SuspensedView>
                <WizardsPage />
              </SuspensedView>
            }
          />
          <Route
            path='crafted/widgets/*'
            element={
              <SuspensedView>
                <WidgetsPage />
              </SuspensedView>
            }
          />
          {/* Profile User */}
          <Route
            path='crafted/account/*'
            element={
              <SuspensedView>
                <AccountPage />
              </SuspensedView>
            }
          />
          {/* End Profile User */}
          <Route
            path='negotiate'
            element={
              <SuspensedView>
                <ChatPage />
              </SuspensedView>
            }
          />
          <Route
            path='negotiate/history/:id'
            element={
              <SuspensedView>
                <ChatPage isHistory={true}/>
              </SuspensedView>
            }
          />

          <Route
            path='apps/user-management/*'
            element={
              <SuspensedView>
                <UsersPage />
              </SuspensedView>
            }
          />
          {/* Page Not Found */}
          <Route path='*' element={<Navigate to='/error/404' />} />
        </Route>
      </Routes>
    </Notification>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--kt-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
